module.exports = __webpack_public_path__ + "static/media/icon-bls.a73553db.svg";